import { useEffect, useState } from 'react';

export function ScrollTopButton() {
	const [visible, setVisible] = useState(false);
	useEffect(() => {
		const onScroll = () => setVisible(window.scrollY > 200);
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => window.removeEventListener('scroll', onScroll);
	}, []);
	if (!visible) {
		return null;
	}
	return (
		<button
			aria-label="Scroll to top"
			className="admin-scroll-top"
			onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
			type="button"
		>
			<svg aria-hidden="true" fill="none" height="20" viewBox="0 0 24 24" width="20">
				<path
					d="M12 19V5m0 0l-6 6m6-6l6 6"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="2"
				/>
			</svg>
		</button>
	);
}
